import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SIGN_IN_ERROR_MESSAGE: `${cleanedFilename(__filename)}-error-message`,
  INFO_MESSAGE: `${cleanedFilename(__filename)}-info-message`,
  FORGOT_PASSWORD_LINK: `${cleanedFilename(__filename)}-forgot-password-link`,
};
